import CrudCustom from '../../../libs/custom/CrudCustom';

let PajakTerutangService = new CrudCustom('/transaksi-pajak-terutangs');
export default PajakTerutangService;
